export default __webpack_public_path__ + "static/media/speed.b37ce8c9.png";